import React from "react";
import { observer } from "mobx-react-lite";

import PageLayout from "../_layout/PageLayout";
import DisplayHeadline from "./components/DisplayHeadline";
import AcceptCollaboration from "./components/AcceptCollaboration";
import RequestOrganization from "./components/RequestOrganization";
import "./LandingPage.scss";

export default observer(function LandingPage() {
  return (
    <div className="landing-page">
      <PageLayout>
        <div className="main-container">
          <DisplayHeadline />
          <div className="content">
            <AcceptCollaboration />
            <RequestOrganization />
          </div>
        </div>
      </PageLayout>
    </div>
  );
});
